export default __webpack_public_path__ + "static/media/custom.f6ce82b8.svg";